module.exports = __webpack_public_path__ + "static/help-header-ca1ab5d576572b788eab981f4725fa91.png";